import moment                from 'moment'
import ApplicationController from '../../support/application_controller'
import I18n                  from '../../support/i18n'

export default class extends ApplicationController {

  static targets = ['timer']

  static values = { startedAt: String }

  connect() {
    this.updateWaitTime = this.updateWaitTime.bind(this)
    this.intervalId     = setInterval(this.updateWaitTime, 1000)
    this.updateWaitTime()
  }

  disconnect() {
    clearInterval(this.intervalId)
  }

  // ==== Controllers

  // ==== Actions

  updateWaitTime() {
    this.timerTarget.textContent = this.formattedTime
    if (this.duration.minutes() >= 7) {
      this.timerTarget.parentNode.classList.add('u-bgc-warning')
    }
  }

  // ==== Getters

  get startedAt() {
    return moment(this.startedAtValue)
  }

  get duration() {
    return moment.duration(moment().diff(this.startedAt))
  }

  get formattedTime() {
    return I18n.l('time.formats.time_elapsed_leading', this.duration.asMilliseconds())
  }

  // ==== Setters

  // ==== Private

  // ==== Channels

}
